import { render, staticRenderFns } from "./StoreTerms.vue?vue&type=template&id=7d7860e4&scoped=true"
import script from "./StoreTerms.vue?vue&type=script&lang=js"
export * from "./StoreTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7860e4",
  null
  
)

export default component.exports